// frontend/src/services/compartilhamentoService.js
import api from './apiService';

const BASE = '/accounts/compartilhamento';

export async function getCompartilhamento() {
  const { data } = await api.get(`${BASE}/`);
  return data; // { concedido, recebidos: [] }
}

export async function convidarCompartilhamento(email) {
  const { data } = await api.post(`${BASE}/convidar/`, { email });
  return data;
}

export async function revogarCompartilhamento(id) {
  const { data } = await api.post(`${BASE}/revogar/`, { id });
  return data;
}

export async function sairDoWorkspace(id) {
  const { data } = await api.post(`${BASE}/sair/`, { id });
  return data;
}

export async function getConvite(token) {
  const { data } = await api.get(`${BASE}/convite/${token}/`);
  return data;
}

export async function aceitarConvite(token) {
  const { data } = await api.post(`${BASE}/convite/${token}/aceitar/`, {});
  return data;
}

export async function recusarConvite(token) {
  const { data } = await api.post(`${BASE}/convite/${token}/recusar/`, {});
  return data;
}
